import React, { useState } from "react";
import { Typography } from "@material-ui/core";
import useStyles from "../../styles/deviceStyle";
import GroupAddRoundedIcon from "@material-ui/icons/GroupAddRounded";
import { useTranslation } from "../../langs/useTranslation";
import { toast } from "@/apis/request";

import VncDisabledDialog from "./VncDisabledDialog";
import HasPermission from "../commons/HasPermission";
import { closeVNCLink } from "@/apis/apiCollection";

const VncMultipleUsersLinkBtn = props => {
  const { t } = useTranslation("device");
  const { VNCLink, handleClickVNCUserLink, VNCExpiredDate, deviceId } = props;
  const classes = useStyles();

  const [open, setOpen] = useState(false);

  const [dialogContent, setDialogContent] = useState("");

  const handleDisableDialogOpen = e => {
    e.preventDefault();
    setOpen(true);
    setDialogContent(`${t("tasks.vncConnectionFailed")}`);
  };

  const handleCloseVNCLink = async () => {
    await closeVNCLink({ deviceId })
    toast.success(t({defaultMessage: "命令已下发"}))
  }

  const handleDisableDialogClose = async () => {
    setOpen(false);
  };

  let htmlButton = (
    <HasPermission permission="device_detail_vnc_multiple_user_link">
      <a
        rel="noopener noreferrer"
        className={classes.VncMultipleUsersLinkBtn_Disabled}
        onClick={handleDisableDialogOpen}
        href="#"
        target="_blank"
      >
        <Typography variant="button">
          {t("deviceDetail.MultipleUsersLink")}
        </Typography>
      </a>
    </HasPermission>
  );
  let htmlExpiredDate = "";

  if (
    (typeof VNCLink === "object" && VNCLink.vnc_link) /* && null !== VNCLink.vnc_link.match(/vnc\-/) */
    || (typeof VNCLink === "string" && !!VNCLink.length)
  ) {
    const vncLink = typeof VNCLink === "object"? VNCLink.vnc_link: VNCLink
    htmlButton = (
      <a
        rel="noopener noreferrer"
        onClick={handleClickVNCUserLink}
        href={vncLink}
        target="_blank"
      >
        <Typography variant="button">
          {t("deviceDetail.MultipleUsersLink")}
        </Typography>
      </a>
    );
    htmlExpiredDate = (
      <Typography variant="caption" color="secondary">
        {" "}
        ( {VNCExpiredDate} )
      </Typography>
    );
  }

  return (
    <div>
      <div className={classes.VncMultipleUsersLinkBtn}>
        <div className={classes.VncMultipleUsersLinkBtn_Icons}>
          <span className={classes.spanInBtn}>VNC</span>
          <GroupAddRoundedIcon
            className={`${classes.marginRight_16} ${classes.svgIconInBtn}`}
          />
        </div>
        {htmlButton}
        {htmlExpiredDate}
        { ((typeof VNCLink === "object" && VNCLink.vnc_link) || (typeof VNCLink === "string" && !!VNCLink.length)) && (
           <a
           rel="noopener noreferrer"
           onClick={handleCloseVNCLink}
          //  href="#"
          //  target="_blank"
           style={{marginLeft: 16}}
         >
           <Typography variant="button">
            {t({defaultMessage: "关闭VNC连接"})}
           </Typography>
         </a>
        )}
      </div>
      <VncDisabledDialog
        open={open}
        onClose={handleDisableDialogClose}
        dialogContent={dialogContent}
      />
    </div>
  );
};

export default React.memo(VncMultipleUsersLinkBtn);
